import { render, staticRenderFns } from "./childmanagement.vue?vue&type=template&id=c991d800&scoped=true&"
import script from "./childmanagement.vue?vue&type=script&lang=js&"
export * from "./childmanagement.vue?vue&type=script&lang=js&"
import style0 from "./childmanagement.vue?vue&type=style&index=0&id=c991d800&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c991d800",
  null
  
)

export default component.exports